/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_ImagesInputs */

const vi_media_field_images = /** @type {(inputs: Media_Field_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh phụ`)
};

/**

* @param {Media_Field_ImagesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_images = /** @type {((inputs?: Media_Field_ImagesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_ImagesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_images(inputs)
});